/**
 * Basis-Klasse für Such-Funktionen
 *
 * @class SP.sitekit.search.SiteSearchController
 */
SP.lang.Class.define("SP.sitekit.search.SiteSearchController", {

	/* Element (wrapper) with attribute 'data-sp-site-search-controller'  */
	_el: null,
	/* Data for this component */
	_data: null,
	/* JavaScript suggest-instance of the search-field to communicate filter-settings (see Suggest.js) */
	_suggestInstance: null,

	/**
	 */
	init: function(el, data) {

		var me = this;
		this._el = el;
		this._data = data;


		this._el.addEventListener("pagination", SP.lang.Function.throttle(function(e) {
			var data = e.detail[0];
			me._storeState(false, data.page);
			me._search(false, {
				scrollToResult: true,
				page: data.page
			});
		}, 500));

		// manage changes of the search-filter (select-boxes)
		this._el.addEventListener("change", function(e) {
			if (e.target.tagName.toLowerCase() === "select") {
				me.setSuggestFilter(e.target);
				me.submit(e.target);
			}
		});

		// manage submit of the filter-form
		var form = this._el.querySelector(me._data.formSelector);
		if (form) {
			form.addEventListener("submit", function(e) {
				me.submit(e.target);
				e.stopPropagation();
				e.preventDefault();
				return false;
			});
		}

		// manage submit of the search-field form
		var searchFieldForm = this._el.querySelector(me._data.searchFormSelector);
		if (searchFieldForm) {
			var suggestField = searchFieldForm.querySelector('[type=search]');
			if (suggestField) {
				me._suggestInstance = suggestField.suggestInstance;
			}
			searchFieldForm.addEventListener("submit", function(e) {
				const submitter = e.submitter;
				/**
				 * Für Formulare die nicht per AJAX abgesendet werden soll.
				 * z.B: für separaten Button der die erweiterte Suche triggern soll
				 * Data-Attribut wird an den Button gesetzt
				 */
				if (submitter && submitter.matches('[data-no-ajax-submit]')) {
					return true;
				}

				me.submit(e.target);
				e.stopPropagation();
				e.preventDefault();
				return false;
			});

			// process 'ENTER' within the search-field
			var searchFieled = searchFieldForm.querySelector('input[type=search]');
			if (searchFieled) {
				searchFieled.addEventListener("keyup", function(e) {
					if (e.keyCode === 13) {
						me.submit(e.target.form);
					} else {
						me._storeState(true);
					}
					e.stopPropagation();
					e.preventDefault();
					return false;
				});
			}

		}

		// bei History-Back die Seite neu laden
		window.addEventListener("popstate", function (popStateEvent) {
			if (popStateEvent.state && popStateEvent.state.isSiteSearch) {
				location.reload();
			}
		});
	},

	/**
	 *
	 * @param {*} elem filter-Element
	 */
	setSuggestFilter : function (elem) {
		var me = this;
		if (me._suggestInstance) {
			var filterField = elem.name.match('.*\\[(.*)\\]\\[\\]')[1];
			var filterValue = elem.value;
			me._suggestInstance.addFilter(filterField, filterValue);
		}
	},

	submit: function(el) {
		var me = this;
		var isFormSubmit = SP.dom.Element.closest(el, me._data.formSelector) !== null || SP.dom.Element.closest(el, me._data.searchFormSelector) !== null;
		me._storeState(isFormSubmit);
		me._search(isFormSubmit, {
			scrollToResult: true,
			focus: el.getAttribute("id")
		});
	},

	getResultElement: function() {
		return this._el.querySelector("[data-sp-search-result]");
	},

	getUrl: function (page) {
		// This function is anonymous, is executed immediately and
		// the return value is assigned to QueryString!
		var qs = [];
		var query = window.location.search.substring(1);
		var vars = query.split("&");
		var hasPage = false;
		for (var i=0;i<vars.length;i++) {
			var pair = vars[i].split("=");
			var name = decodeURIComponent(pair[0]);
			if (name === "sp:page") {
				qs.push(pair[0] + "=" + page);
				hasPage = true;
			} else {
				qs.push(vars[i]);
			}
		}
		if (!hasPage) {
			qs.push(encodeURIComponent("sp:page") + "=" + page);
		}
		return window.location.pathname + "?" + qs.join("&");
	},


	_search: function(isFormSubmit, options) {
		var me = this;

		if (!options) {
			options = {};
		}

		var formData = this._getFormData(isFormSubmit);

		formData.append("sp:out", "htmlFragment");
		formData.append("processComponents", me._data.htmlFragments.result.processComponents);
		formData.append("component", me._data.htmlFragments.result.component);
		formData.append("action", "submit");
		if (options.page) {
			formData.append("sp:page", options.page);
		}

		SP.net.http.Client.fetch(document.location.pathname, { method: "POST", body: formData })
			.then(function(xhr, response) {

				try {

					var resultEl = me.getResultElement();

					if (resultEl) {
						SP.dom.Element.replace(resultEl, response);
					} else {
						SP.dom.Element.append(me._el, response);
					}
					//me._loaderEl.classList.remove("SP-isLoading");

					resultEl = me.getResultElement();
					if (options.scrollToResult === true) {
						window.scroll({
							top: Math.max(0, (window.scrollY || window.pageYOffset) + resultEl.getBoundingClientRect().top - 110),
							left: 0,
							behavior: "smooth"
						});
					}
					if (options.focus) {
						var focusEl = resultEl.querySelector("#" + options.focus);
						if (focusEl) {
							focusEl.focus({
								preventScroll: true
							});
						}
					}
					me._firePagintionFinishedEvent();
				} catch (e) {
					console.error(e);
				}
			}).catch(function(e, xhr, response) {
				console.error(e);
			});
	},

	/**
	 * TODO: auf TS refactorn => https://github.com/Stanko/animated-scroll-to
	 * windows.scroll meldet nicht wenn zu ende gescrollt wurde, daher dieser Workaround
	 */
	_firePagintionFinishedEvent : function () {
		var me = this;
		setTimeout(function () {
			SP.dom.Event.fireEvent(me._el, "paginationFinished", [{source: "siteSearch"}], true);
		}, 1000);
	},

	_storeState: function (isFormSubmit, page) {
		var formData = this._getFormData(isFormSubmit);
		if (page) {
			formData.append("sp:page", page);
		}
		formData.append('action', 'submit');

		var queryString = SP.sitekit.Form.encodeURIFormData(formData);
		history.pushState({ isSiteSearch : true }, null, window.location.pathname + "?" + queryString);
	},

	/**
	 * gets all request-parameter
	 * @param {*} fromLocationPath defines if the return value will be
	 * created by the queryString instead the known forms
	 * @returns FormData
	 */
	_getFormData : function(fromLocationPath) {
		var me = this;
		fromLocationPath = fromLocationPath || false;

		// manage submit of the filter-form
		var form = this._el.querySelector(me._data.formSelector);
		// manage submit of the search (field) form
		var searchFieldForm = this._el.querySelector(me._data.searchFormSelector);

		var formData = new FormData();

		if (fromLocationPath === true) {
			if (form !== null) {
				formData = new FormData(form);
			}

			if (searchFieldForm !== null) {
				var searchFormData = new FormData(searchFieldForm);
				searchFormData.forEach(function(entry, key) {
					formData.set(key, entry);
				});
			}
		} else if (location.search) {
			// Sonderfall für Facetten in Kombination mit der Slider-Pagination
			// URL-Parameter an das FormData anhängen
			var parameterPairs = location.search.substring(1).split("&");
			var parameterPair = null;
			for (var index in parameterPairs) {
				parameterPair = decodeURIComponent(parameterPairs[index]).split("=");
				var param = decodeURIComponent(parameterPair[0]);
				if (param !== "action" && param !== "sp:page" && parameterPair[1]) {
					formData.append(parameterPair[0], parameterPair[1]);
				}
			}
		}
		return formData;
	}
});